export default __webpack_public_path__ + "static/media/page6.00e8b952.webp";